import { Table } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { useAppSelector } from '../../../redux/hooks'
import { priceRenderer } from '../../utils/propertyDetailPriceHelpers'

export interface PropertyDetailPriceUnitSaleTableSummaryProps {
  area?: number | null
}

export const PropertyDetailPriceUnitSaleTableSummary: FunctionComponent<PropertyDetailPriceUnitSaleTableSummaryProps> =
  memo(props => {
    const mainLocality = useAppSelector(
      state => state.property.price.data?.saleOffer.mainLocality
    )

    if (!mainLocality) return null

    const averagePriceM2 = Number(mainLocality.averagePriceM2 || 0)
    const total = averagePriceM2 * (props.area || 0)

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={0}>
          <strong>Souhrn ({mainLocality.name})</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={1} className="!text-right">
          {priceRenderer(total)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} className="!text-right">
          {priceRenderer(averagePriceM2)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} className="!text-right">
          ---
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} className="!text-right">
          {mainLocality.transactionsCount ?? '0'}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    )
  })
